export function eventSummaryButtonStyle(color) {
  return {
    width: '100%',
    height: 22,
    border: `1.5px solid ${color.border}`,
    borderRadius: 6,
    padding: '0 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: color.background,
    color: color.color,
    fontSize: 10,
    fontWeight: 950,
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
}

export const detailPanelStyle = {
  marginTop: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg)',
  overflow: 'hidden',
};

export const detailHeaderStyle = {
  minHeight: 38,
  padding: '0 12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  color: 'var(--text)',
  fontSize: 13,
  fontWeight: 950,
  background: 'rgba(37,99,235,0.07)',
  borderBottom: '1px solid var(--border)',
};

export const detailListStyle = {
  display: 'grid',
  gap: 6,
  padding: 10,
};

export const detailItemStyle = {
  minHeight: 38,
  border: '1px solid var(--border)',
  borderRadius: 7,
  background: 'var(--bg-card)',
  display: 'grid',
  gridTemplateColumns: '58px 56px minmax(0, 1fr)',
  alignItems: 'center',
  gap: 8,
  padding: '0 10px',
  color: 'var(--text)',
  cursor: 'pointer',
  textAlign: 'left',
};

export const detailDateStyle = {
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 900,
};

export function detailTypeStyle(color) {
  return {
    height: 24,
    borderRadius: 999,
    border: `1px solid ${color.border}`,
    background: color.background,
    color: color.color,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 950,
  };
}

export const detailNameStyle = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: 13,
  fontWeight: 950,
};

export const detailEmptyStyle = {
  padding: '16px 12px',
  color: 'var(--text-sub)',
  fontSize: 13,
  fontWeight: 800,
};

export const upcomingSectionStyle = {
  marginTop: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg)',
  overflow: 'hidden',
};

export const upcomingTitleStyle = {
  padding: '9px 11px',
  color: 'var(--text)',
  fontSize: 13,
  fontWeight: 950,
  borderBottom: '1px solid var(--border)',
  background: 'rgba(148,163,184,0.08)',
};
